var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2303 0H-0.154297V10H15.2303V0Z",
    fill: "#272622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42383 2.03906C7.76998 2.03906 6.42383 3.34676 6.42383 5.0006C6.42383 6.65445 7.76998 7.96214 9.38537 7.96214C11.0008 7.96214 12.3469 6.61599 12.3469 5.0006C12.3854 3.34676 11.0392 2.03906 9.42383 2.03906Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73107 2.03906C4.11568 2.03906 2.76953 3.34676 2.76953 5.0006C2.76953 6.65445 4.11568 7.96214 5.73107 7.96214C7.34645 7.96214 8.73107 6.65445 8.73107 5.0006C8.73107 3.34676 7.38491 2.03906 5.73107 2.03906Z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73203 5.00045C8.73203 4.07737 8.30895 3.23122 7.57818 2.6543C6.27049 3.6543 6.07818 5.53891 7.07818 6.80814C7.23203 7.00045 7.38587 7.1543 7.57818 7.30814C8.30895 6.76968 8.73203 5.92353 8.73203 5.00045Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.1c9511ab888d843c5f3d53d2dd5c24cc.svg";
export { ForwardRef as ReactComponent };